<template>
  <div class="account-security">
    <div class="title">
      <img src="@/assets/img/profile/shouji.png" alt="">
      <span>修改密码</span>
    </div>

    <div class="account-box">
      <div v-if="isShow">
        <FormInput :isShow.sync='isShow' />
      </div>

      <div v-if="!isShow">
        <FormInputPass />
      </div>
    </div>
  </div>
</template>

<script>
import FormInput from "./components/FormInput";
import FormInputPass from "./components/FormInputPass";
export default {
  name: "AccountSecurity",
  components: {
    FormInput,
    FormInputPass
  },
  data() {
    return {
      isShow: true
    };
  },
  created() {
    this.isShow = true;
  }
};
</script>

<style lang="less" scoped>
.account-security {
  padding-right: 54px;
  position: relative;
  width: 100%;
  height: 100%;
  .title {
    display: flex;
    align-items: center;

    span {
      font-size: 16px;
      margin-left: 8px;
    }
  }

  .account-box {
    position: absolute;
    top: 140px;
    left: 170px;
    width: 450px;
  }
}
</style>